import React, { useCallback, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardBody } from "reactstrap";
import classnames from "classnames";
import { TABS, TABS_BUTTONS } from "./constants";
import Settings from "pages/meter-management/meters/meterDetails/Tabs/getMeterStatus/Tabs/Settings";
import HardwareReports from "pages/meter-management/meters/meterDetails/Tabs/getMeterStatus/Tabs/HardwareReports";
import Alerts from "pages/meter-management/meters/meterDetails/Tabs/getMeterStatus/Tabs/Alerts";
import CumulativewReports from "pages/meter-management/meters/meterDetails/Tabs/getMeterStatus/Tabs/CumulativewReports";
import MeterStatus from "pages/meter-management/meters/meterDetails/Tabs/getMeterStatus/Tabs/MeterStatus";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    borderRadius: 30,
    padding: 30,
  },
  cardBody: {
    padding: 0,
  },
  tabs: {
    display: "flex",
    padding: "0 30px",
    fontSize: 13,
    fontWeight: 600,
  },
  active: {
    backgroundColor: "#FFFFFF!important",
  },
  tab: {
    boxShadow: "0px -10px 20px rgba(0, 0, 0, 0.05)",
    backgroundColor: "#E1E1E1",
    padding: 18,
    borderRadius: "10px 10px 0px 0px",
    marginRight: 10,

    "&:hover": {
      cursor: "pointer",
    },
  },
});

const GetMeterStatusTabs = ({ id }) => {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(TABS.SETTINGS);

  const onTabClick = useCallback(e => {
    const tab = e.target.dataset.tab;
    setActiveTab(tab);
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.tabs}>
        {TABS_BUTTONS.map(item => (
          <div
            key={item.key}
            className={classnames(classes.tab, activeTab === item.key && classes.active)}
            data-tab={item.key}
            onClick={onTabClick}
          >
            {item.title}
          </div>
        ))}
      </div>
      <Card className={classes.container}>
        <CardBody className={classes.cardBody}>
          {activeTab === TABS.SETTINGS && <Settings id={id} />}
          {activeTab === TABS.HARDWARE_REPORTS && <HardwareReports id={id} />}
          {activeTab === TABS.ALERTS && <Alerts id={id} />}
          {activeTab === TABS.CUMULATIVE_REPORTS && <CumulativewReports id={id} />}
          {activeTab === TABS.METER_STATUS && <MeterStatus id={id} />}
        </CardBody>
      </Card>
    </div>
  );
};

export default GetMeterStatusTabs;
